import createIcon from '../../createIcon';

/**
 * @component @name BookmarkRemove
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgN0gxNFY1SDIwVjdaTTE4IDEwLjlDMTcuNjggMTAuOTcgMTcuMzQgMTEgMTcgMTFDMTQuMjQgMTEgMTIgOC43NiAxMiA2QzEyIDQuODcgMTIuMzcgMy44NCAxMyAzSDZDNC45IDMgNCAzLjkgNCA1VjIxTDExIDE4TDE4IDIxVjEwLjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BookmarkRemove = createIcon('BookmarkRemove', [
  [
    'path',
    {
      d: 'M20 7H14V5H20V7ZM18 10.9C17.68 10.97 17.34 11 17 11C14.24 11 12 8.76 12 6C12 4.87 12.37 3.84 13 3H6C4.9 3 4 3.9 4 5V21L11 18L18 21V10.9Z',
      key: 's3lkov',
    },
  ],
]);

export default BookmarkRemove;
